export const buttons = {
  md: '40px',
};
